import { createCrudService } from './createCrudService';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { MOCK_USERS } from 'mock/users.mock';

export const toUser = (raw) =>
  raw && {
    id: raw.id,
    fullName: raw.full_name ?? raw.fullName ?? '',
    phoneNumber: raw.phone_number ?? raw.phoneNumber ?? '',
    roleId: raw.role_id ?? raw.roleId ?? '',
    roleName: raw.role_name ?? raw.roleName ?? '',
    status: raw.status,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

const toPayload = (model) => ({
  full_name: model.fullName,
  phone_number: model.phoneNumber,
  role_id: model.roleId,
  status: model.status,
  ...(model.password ? { password: model.password } : {}),
});

const seed = MOCK_USERS.map(({ password, ...rest }) => rest);

export const userService = createCrudService({
  endpoints: API_ENDPOINTS.USERS,
  toModel: toUser,
  toPayload,
  mockSeed: seed,
  idPrefix: 'user',
});

export default userService;
